
    <template>
      <section class="relax-doc">
        <h1>DatePicker 日期选择</h1>
<blockquote>
<p>时间选择器，可以选择日期</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>使用 <code>v-model</code> 实现数据的双向绑定</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-date-picker v-model=&quot;value&quot; placeholder=&quot;YYYY-MM-DD&quot; /&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const value = ref('')

      return {
        value
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="yi-jian-xuan-zhi"><a class="header-anchor" href="#yi-jian-xuan-zhi"></a> 一键选值</h2>
<blockquote>
<p>设置 <code>onetap</code> 开启一键选值</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-date-picker v-model=&quot;value&quot; onetap placeholder=&quot;YYYY-MM-DD&quot; /&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const value = ref('')

      return {
        value
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jin-yong"><a class="header-anchor" href="#jin-yong"></a> 禁用</h2>
<blockquote>
<p>设置 <code>disabled</code> 禁用日期选择</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-date-picker disabled placeholder=&quot;YYYY-MM-DD&quot; /&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_date_picker = _resolveComponent("x-date-picker")

  return (_openBlock(), _createBlock(_component_x_date_picker, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event),
    placeholder: "YYYY-MM-DD"
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const value = ref('')

      return {
        value
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_date_picker = _resolveComponent("x-date-picker")

  return (_openBlock(), _createBlock(_component_x_date_picker, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event),
    onetap: "",
    placeholder: "YYYY-MM-DD"
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const value = ref('')

      return {
        value
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_date_picker = _resolveComponent("x-date-picker")

  return (_openBlock(), _createBlock(_component_x_date_picker, {
    disabled: "",
    placeholder: "YYYY-MM-DD"
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  